import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useCallbackRef } from '../hooks';
import Card from './card';
import { animatedWrapperStyle } from './styles';
import useHeight from './use-height';
function Toast({ autoHideDuration, description, disableAutoHide, onClose, size = 'medium', title, variant = 'info', }) {
    // A flag to trigger enter / exit animation
    const [isVisible, setIsVisible] = useState(true);
    // For exit animation to work smoothly, height of animated wrapper is required
    const wrapperRef = useRef(null);
    const height = useHeight(wrapperRef);
    // Internal timer, a timeout after which the Toast is closed automatically
    const autoCloseTimer = useRef();
    const handleClose = useCallbackRef(() => {
        onClose();
    });
    // Close Toast after close button is clicked
    // First it triggers exit animation, after that it clears internal timer
    // To let exit animation finish before Toast unmount, close callback is triggered after a delay
    // Finally completely remove the Toast
    function forceClose() {
        if (isVisible) {
            setIsVisible(false);
            clearTimeout(Number(autoCloseTimer.current));
            setTimeout(() => {
                handleClose();
            }, 600);
        }
    }
    // Close toast after timeout, tracked internally
    useEffect(() => {
        if (isVisible && !disableAutoHide) {
            autoCloseTimer.current = setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => {
                    handleClose();
                }, 600);
            }, autoHideDuration);
        }
        return () => {
            clearTimeout(Number(autoCloseTimer.current));
        };
    }, [isVisible, disableAutoHide, autoHideDuration, handleClose]);
    return (_jsx("li", Object.assign({ css: animatedWrapperStyle({ height, isVisible }), ref: wrapperRef }, { children: _jsx(Card, Object.assign({}, { description, size, title, variant }, { onClose: forceClose })) })));
}
export default Toast;
